import React, { FC } from "react";
import { Helmet } from "react-helmet";

interface HeaderProps {
  title: string;
}

const Header: FC<HeaderProps> = ({ title }) => {
  return (
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <Helmet>
      <title>{process.env.REACT_APP_TITLE + " | " + title}</title>
    </Helmet>
  );
};

export default Header;
